import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from 'react-select';
export function Input(props) {
  var ariaDescribedByAttribute;
  var passed_describedby = props.selectProps['aria-describedby'];
  if (props['aria-describedby'] && passed_describedby) {
    ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
  } else {
    ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
  }
  return /*#__PURE__*/React.createElement(components.Input, _extends({}, props, {
    "aria-describedby": ariaDescribedByAttribute
  }));
}